import React, {useEffect, useRef, useState} from 'react'
import { connect } from 'react-redux'
import { alertActions, commonActions, certboxActions } from '../../../../../store/actions'
import moment from 'moment'
import Alert from '../../../../../module/alert/Alert'
import { commons } from '../../../../../hook/common'
import PdfViewer from '../../../../../module/pdf/PdfViewer'
import '../../../../../assets/css/spin.css';

/*
   시험성적서, 계약 form
 */
const CertboxForm3 = (props) => {
  const [state, setState] = useState({})
  const [commoncode, setCommoncode] = useState({})
  const [isShowPdf, setIsShowPdf] = useState(false) //삭제 버튼 표시 여부
  const [showResponse, setShowResponse] = useState()
  const [showFileNm, setShowFileNm] = useState()
  const [blobResponse, setBlobResponse] = useState()
  const [docid, setDocid] = useState()
  const [crtCd, setCrtCd] = useState()
  const [brno, setBrno] = useState()
  const [oldYn, setOldYn] = useState()
  const [fileId, setFileId] = useState()
  const [printYn, setPrintYn] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const xhrRef = useRef(null)

  const gnrlInfoCn = JSON.parse(props.data?.gnrlInfoCn)


  useEffect(() => {
    props.getCommonCode({ mainCd: ['CRT_FORM_TP', 'CRT_PERFORM_TP', 'CRT_SUBMIS_TP', 'CRT_DV'] })
  }, [])

  useEffect(() => {
    setCommoncode({
      ...commoncode,
      ...props.commoncode,
    })

    setState({
      ...state,
      docFormatNm: props.commoncode?.CRT_FORM_TP?.find((co) => co.cd === props.data?.docFormat)?.cdName,
      docTypeNm: props.commoncode?.CRT_SUBMIS_TP?.find((co) => co.cd === props.data?.submisType)?.cdName,
      submissionNm: props.commoncode?.CRT_SUBMIS_TP?.find((co) => co.cd === props.data?.submission)?.cdName,
      crtNm: props.commoncode?.CRT_DV?.find((co) => co.cd === props.data?.crtCd)?.cdName,
    })
  }, [props.commoncode])

  console.log('props.commoncode = ', props.commoncode)
  console.log('props.commoncode.CRT_DV = ', props.commoncode['CRT_DV'])
  /*
    console.log('props = ', props);
    console.log('props.commoncode?.CRT_DV = ', props.commoncode?.CRT_DV?.cd);
    console.log('props.data = ', props.data);
    console.log('state = ', state);
    */

  const onShowOut = (e) => {
    e.preventDefault()
  }

  const eventHandler = (e, crtSeq) => {
    e.preventDefault()
    document.querySelectorAll('.attach-file').forEach((a)=>{
      if(a.id == crtSeq){
        a.className = 'attach-file active'
      }else{
        a.className = 'attach-file'
      }
    })
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (crtCd, docid, brno, fileObj) => {
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }
    setIsLoading(true)
    fileList.forEach((val, idx, arr) => {
      if (crtCd === '03' && fileList[idx].readYn === 'N') {
        const params = {
          docId: docid,
          fileId: fileList[idx].fileId,
          brno: brno,
        }
        props.getDownLoad(params)
      }

      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
        let xhr = new XMLHttpRequest()
        xhrRef.current = xhr

        xhr.responseType = 'blob'
        xhr.open('GET', url)
        xhr.send()
        xhr.onload = function () {
          setIsLoading(false)
          xhrRef.current = null
          if (xhr.status === 200) {
            // HTTP가 잘 동작되었다는 뜻.
            setShowResponse(window.URL.createObjectURL(xhr.response))
            setBlobResponse(xhr.response)
            setShowFileNm(val['originFileNm'])
            setIsShowPdf(true)
            setDocid(docid)
            setCrtCd(crtCd)
            setBrno(brno)
            setOldYn('N')
            setFileId(fileList[idx].fileId)
            setPrintYn(fileList[idx].printYn)
          } else {
            props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
            return
          }
        }
        // 에러 처리 추가
        xhr.onerror = function () {
          setIsLoading(false) // 또는 props.setLoading(false)
          xhrRef.current = null
          props.error({message: 'PDF 파일 다운로드에 실패했습니다.'})
        }

      }, 3000)
    })
  }

  const handleCancel = () => {
    if (xhrRef.current) {
      xhrRef.current.abort()   // ✅ 실제 요청 중단
      setIsLoading(false)
      console.log('요청취소')
    }
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  // let onPdfDown = (crtCd, docid, brno, fileObj) => {
  //   let fileList = []
  //   if (fileObj) {
  //     fileList.push(fileObj)
  //   }
  //   if (!fileList || !fileList.length) {
  //     props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
  //     return
  //   }
  //   fileList.forEach((val, idx, arr) => {
  //     if (crtCd === '03' && fileList[idx].readYn === 'N') {
  //       const params = {
  //         docId: docid,
  //         fileId: fileList[idx].fileId,
  //         brno: brno,
  //       }
  //       props.getDownLoad(params)
  //     }
  //
  //     setTimeout(() => {
  //       let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
  //       let xhr = new XMLHttpRequest()
  //       xhr.responseType = 'blob'
  //       xhr.open('GET', url)
  //       xhr.send()
  //       xhr.onload = function () {
  //         if (xhr.status === 200) {
  //           // HTTP가 잘 동작되었다는 뜻.
  //           setShowResponse(window.URL.createObjectURL(xhr.response))
  //           setBlobResponse(xhr.response)
  //           setShowFileNm(val['originFileNm'])
  //           setIsShowPdf(true)
  //           setDocid(docid)
  //           setCrtCd(crtCd)
  //           setBrno(brno)
  //           setOldYn('N')
  //           setFileId(fileList[idx].fileId)
  //           setPrintYn(fileList[idx].printYn)
  //         } else {
  //           props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
  //           return
  //         }
  //       }
  //     }, 30)
  //   })
  // }

  return (
    <>
      <h3 className="h3-tit first">문서정보</h3>
      <table className="tbl-view">
        <caption>발급번호, 문서유형, 발급일시, 만료일시, 제출처, 발급기관 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">발급번호</th>
            <td>{props.data?.docid}</td>
          </tr>
          <tr>
            <th scope="row">문서유형</th>
            <td>{props.commoncode?.CRT_DV?.find((co) => co.cd === props.data?.crtCd)?.cdName}</td>
          </tr>
          <tr>
            <th scope="row">발급일시</th>
            <td>
              {props.data?.issuedt === null || props.data?.issuedt === ''
                ? '-'
                : moment(props.data?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
            </td>
          </tr>
          <tr>
            <th scope="row">만료일시</th>
            <td>
              {props.data?.crtfExpryDt === null || props.data?.crtfExpryDt === ''
                ? '-'
                : moment(props.data?.crtfExpryDt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
            </td>
          </tr>
          <tr>
            <th scope="row">제출처</th>
            <td>{props.data?.submission}</td>
          </tr>
          <tr>
            <th scope="row">발급기관</th>
            <td>{props.data?.prchsNm}</td>
          </tr>
        </tbody>
      </table>

      <h3 className="h3-tit first">일반정보</h3>

      <table className="tbl-view">
        <caption>
          신청자명, 휴대폰번호, Email, 업체명, 사업자등록번호, 업체주소, 시험방법, 시험성적서용도, 시료명, 시험시작일자, 시험종료일자
          항목으로 구성
        </caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">신청자명</th>
            <td>{gnrlInfoCn?.aplcnt_nm}</td>
          </tr>
          <tr>
            <th scope="row">휴대폰번호</th>
            <td>{gnrlInfoCn?.mobile_no}</td>
          </tr>
          <tr>
            <th scope="row">Email</th>
            <td>{gnrlInfoCn?.email}</td>
          </tr>
          <tr>
            <th scope="row">업체명</th>
            <td>{gnrlInfoCn?.entrps_nm}</td>
          </tr>
          <tr>
            <th scope="row">사업자등록번호</th>
            <td>{gnrlInfoCn?.brno}</td>
          </tr>
          <tr>
            <th scope="row">업체주소</th>
            <td>{gnrlInfoCn?.entrps_addr}</td>
          </tr>
          <tr>
            <th scope="row">시험방법</th>
            <td>{gnrlInfoCn?.expr_mth}</td>
          </tr>
          <tr>
            <th scope="row">시험성적서용도</th>
            <td>{gnrlInfoCn?.test_report_prpos}</td>
          </tr>
          <tr>
            <th scope="row">시료명</th>
            <td>{gnrlInfoCn?.splore_nm}</td>
          </tr>
          <tr>
            <th scope="row">시험시작일자</th>
            <td>
              {gnrlInfoCn?.test_bgng_dt === null || props.data?.test_bgng_dt === ''
                ? '-'
                : moment(gnrlInfoCn?.test_bgng_dt, 'YYYYMMDD').format('YYYY.MM.DD')}
            </td>
          </tr>
          <tr>
            <th scope="row">시험종료일자</th>
            <td>
              {gnrlInfoCn?.test_end_dt === null || props.data?.test_end_dt === ''
                ? '-'
                : moment(gnrlInfoCn?.test_end_dt, 'YYYYMMDD').format('YYYY.MM.DD')}
            </td>
          </tr>
        </tbody>
      </table>

      <h3 className="h3-tit">발급이력</h3>
      <table className="tbl-view">
        <caption>발급일자 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">발급일자</th>
            <td>{props.data?.issuedt && moment(props.data?.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD')}</td>
          </tr>
        </tbody>
      </table>
      <div className="btn-block">
        <span className="right">
          {props.data?.fileGroupId !== null && props.data?.fileNewList?.length !== 0 && props.data?.fileNewList?.length === 1 && (
              <span className="attach-wrap">
                {props.data?.fileNewList?.map((fileObj, index) => (
                    <a
                        key={index}
                        href="#"
                        className="btn-primary md"
                        //className="attach attach-link"
                        onClick={(e) => {
                          e.preventDefault()
                          onPdfDown(props.data?.crtCd, props.data?.docid, gnrlInfoCn?.brno, fileObj)
                          return
                        }}
                    >
                      증명서 열람

                    </a>
                ))}
              </span>
          )}
          {props.data?.fileGroupId !== null && props.data?.fileNewList?.length !== 0 && props.data?.fileNewList?.length !== 1 && (
              <span className="attach-wrap">
            <a
                href="#"
                className="btn-primary md"
                //className="attach attach-link"
                onClick={(e) => {
                  //e.preventDefault()
                  //props.onPDFView()
                  eventHandler(e, props.data?.crtSeq)
                }}
            >
              증명서 열람
            </a>
            <ul
                id={props.data?.crtSeq}
                // className={active === certboxObj.crtSeq + index ? 'attach-file active' : 'attach-file'}
                className='attach-file'
            >
              {props.data?.fileNewList?.map((fileObj, index) => (
                  <li key={index}>
                    <a
                        onClick={(e) => {
                          e.preventDefault()
                          onPdfDown(props.data?.crtCd, props.data?.docid,gnrlInfoCn?.brno,fileObj)
                          onShowOut(e)
                          return
                        }}
                    >
                      {fileObj.originFileNm}
                    </a>
                  </li>
              ))}
            </ul>
          </span>
          )}
          <a
              href="#"
              className="btn-secondary md"
              onClick={(e) => {
                e.preventDefault()
                props.goList()
              }}
          >
            목록
          </a>
        </span>
      </div>
      {isShowPdf === true && (
        <PdfViewer
          blobResponse={blobResponse}
          showResponse={showResponse}
          fileNm={showFileNm}
          crtCd={crtCd}
          docid={docid}
          brno={brno}
          oldYn={oldYn}
          fileId={fileId}
          printYn={printYn}
          onClose={() => setIsShowPdf(false)}
        />
      )}
      {isLoading === true && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            // 1. 세로 방향으로 배치 (-important!)
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9998
          }}>
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999,
            }}>
            </div>
            <div style={{
              width: '50px',
              height: '50px',
              border: '5px solid #f3f3f3',
              borderTop: '5px solid #3498db',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }} />
            {/* 2. 추가할 코멘트 텍스트 */}
            <p style={{
              marginTop: '20px', // 스피너와의 간격
              marginBottom: '20px',
              color: '#ffffff',  // 어두운 배경이므로 흰색 글씨
              fontSize: '16px',
              fontWeight: '500',
              textAlign: 'center'
            }}>
              파일을 조회하고 있습니다. <br/>
              잠시만 기다려주세요.
            </p>
            {/*<button style={{zIndex: 9999}} onClick={() => handleCancel()} className="btn-gray sm"> 취소 </button>*/}

          </div>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    commoncode: state.commoncode?.co,
  }
}

const actionCreators = {
  getCommonCode: commonActions.getCommonCode,
  getFile: certboxActions.getFile,
  error: alertActions.error,
  getDownLoad: certboxActions.getDownLoad,
}

export default connect(mapStateToProps, actionCreators)(CertboxForm3)
